import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';
import { GnbMenu } from '../constants';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0 16px;
`;

export const AvatarWrapper = styled.div`
  position: relative;
  cursor: pointer;
`;

export const Menu = styled.div`
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translate3d(-50%, 100%, 0);
  width: 117px;
  padding: 12px 0;
  border: 1px solid ${({ theme }) => theme.colors.gray600};
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.15);
  background-color: #fff;
  border-radius: 4px;
  z-index: 10;
`;

export const MenuItem = styled.a<Pick<GnbMenu, 'isNew'>>`
  display: block;
  padding: 4px 16px;
  color: ${({ theme }) => theme.colors.gray800};
  ${getFontStyle('midium150_B3')};

  &:hover {
    background-color: ${({ theme }) => theme.colors.gray300};
  }

  span {
    position: relative;

    ${({ isNew }) =>
      isNew &&
      css`
        &::after {
          content: 'new';
          position: absolute;
          top: 1px;
          right: -22px;
          color: ${({ theme }) => theme.colors.magenta500};
          ${getFontStyle('midium120_C2')}
        }
      `}
  }
`;

export const ButtonBookmark = styled.a`
  position: relative;
  top: -3px;
  display: block;
  width: 22px;
  height: 22px;
`;

export const ButtonLogin = styled.a`
  color: ${({ theme }) => theme.colors.gray700};
  ${getFontStyle('midium150_C1')};
`;
